import classes from "./LiveButton.module.scss";
import image from "components/icons/liveButton.webp";
import { links } from "./config/liveButton";
import { useDeviceType } from "hooks";
import { deviceTypeEnum } from "hooks/useDeviceType";

const LiveButton = () => {
  const isDesktop = useDeviceType() === deviceTypeEnum.DESKTOP;

  const handleClick = () => {
    const url = isDesktop ? links.desktop : links.mobile;
    window.open(url, "_blank");
  };

  return (
    <div className={classes.liveButton} onClick={handleClick}>
      <span className={classes.imageWrapper}>
        <img className={classes.image} src={image} width={26} height={26} alt="" />
      </span>
      <div className={classes.textWrapper}>
        <span className={classes.text}>LIVE</span>
      </div>
    </div>
  );
};

export default LiveButton;
